import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


import './App.css';

import Privacy from './Privacy/Privacy';
import DbPrivacy from './Privacy/DbPrivacy';
import CardPage from './Card/CardPage';
import ServicePage from './Services/ServicePage';
import TryPage from './Try/Try';
import Contact from './Contact/ContactPage';
import DailyBriefing from './DailyBriefing/DailyBriefing';

import Home from './Home/Home';

function DoodlesRedirect() {
  useEffect(() => {
    window.location.href = '/doodles.html';
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/physical' element={<CardPage />} />
        <Route path='/services' element={<ServicePage />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/try' element={<TryPage />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/dbPrivacy' element={<DbPrivacy />} />
        <Route path='/dailyBreifing' element={<DailyBriefing />} />
                <Route path='/doodles' element={<DoodlesRedirect />} />
        <Route path='*' element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
